module.exports = __webpack_public_path__ + "img/submit-bg.c0ec609.png";